import { IconButton, IconButtonProps } from '@mui/material';

interface AddActionButtonProps extends Omit<IconButtonProps, 'children'> {
    sizePx?: number;
    iconSizePx?: number;
}

const AddActionButton = ({
    sizePx = 38,
    iconSizePx = 16,
    sx,
    ...props
}: AddActionButtonProps) => {
    return (
        <IconButton
            {...props}
            aria-label={props['aria-label'] ?? 'Ajouter'}
            sx={{
                width: sizePx,
                height: sizePx,
                borderRadius: '8px',
                border: theme => `1px dashed ${theme.palette.neutralWhite.main}`,
                color: 'neutralWhite.main',
                '&:hover': { backgroundColor: 'transparent' },
                '& i': { fontSize: `${iconSizePx}px` },
                ...sx,
            }}>
            <i className="fi fi-br-plus" />
        </IconButton>
    );
};

export default AddActionButton;
